export const validation = {
    userType:'User type required',
    description:'Ads Description is required',
    displayOrder:"Select display order",
    maxValid: 'Please enter less than or equal to 100 characters.',
};
